import service from '@/store/services/rutas-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  line: {},
  listActive: {},
  ruta: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_LINE: (state, line) => {
    state.line = line;
  },
  SET_LIST_ACTIVE: (state, listActive) => {
    state.listActive = listActive;
  },
  SET_RESOURCE: (state, ruta) => {
    state.ruta = ruta;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  line({commit, dispatch}, params = {}) {
    return service.line(params, this.$axios)
      .then(({line, meta}) => {
        commit('SET_LINE', line);
        commit('SET_META', meta);
      });
  },

  listActive({ commit, dispatch }, params) {
    return service.listActive(params).then(({ listActive }) => {
      commit("SET_LIST_ACTIVE", listActive);
    });
  },

  listRutaTramos({commit, dispatch}, params) {
    return service.listRutaTramos(params, this.$axios)
      .then((ruta) => { commit('SET_LIST', ruta); });
  },

  add({commit, dispatch}, params) {
    return service.add(params, this.$axios)
      .then((ruta) => { commit('SET_RESOURCE', ruta); });
  },

  addTramo({commit, dispatch}, params) {
    return service.addTramo(params, this.$axios)
      .then((ruta_tramo) => { commit('SET_RESOURCE', ruta_tramo); });
  },

  update({commit, dispatch}, params) {
    return service.update(params, this.$axios)
      .then((ruta) => { commit('SET_RESOURCE', ruta); });
  },

  destroyTramo({commit, dispatch}, params) {
    return service.destroyTramo(params, this.$axios);
  },

  activate({commit, dispatch}, params) {
    return service.activate(params, this.$axios)
      .then((ruta) => { commit('SET_RESOURCE', ruta); });
  },

  deactivate({commit, dispatch}, params) {
    return service.deactivate(params, this.$axios)
      .then((ruta) => { commit('SET_RESOURCE', ruta); });
  },
};

const getters = {
  list: state => state.list,
  line: state => state.line,
  listActive: state => state.listActive,
  listRutaTramos: state => state.list,
  list: state => state.list,
  listTotal: state => state.meta.total, 
  ruta: state => state.ruta,
  url: state => state.url
};

const rutas = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default rutas;
